import { GroupsLogoStore } from '@front-app/store/singletons/Groups';
import { EventsLogoStore } from '@front-app/store/singletons/Events';
import { Routes } from '@front-app/constants/routes';
import { SearchOption } from '@front-app/components/search/useSearch';
import { SearchResult, SearchResultType, search } from '@front-app/services/SearchApi/SearchApi';
import { SearchType } from '@front-app/services/SearchApi/SearchModel';

export async function useContentSearch(type: SearchType, resultType: SearchResultType, query: string): Promise<SearchOption<SearchResult>[]> {
	const getSubtitle = (searchResult: SearchResult) => {
		switch (searchResult.type) {
			case SearchResultType.COMMUNITY: return 'community.search.source';
			case SearchResultType.GROUP: return 'groups.search.source';
			case SearchResultType.EVENT: return 'events.search.source';
			default: return '';
		}
	};

	const getUrl = (searchResult: SearchResult) => {
		switch (searchResult.type) {
			case SearchResultType.COMMUNITY: return '';
			case SearchResultType.GROUP: return { name: Routes.GROUP_MAIN, params: { groupId: searchResult.id, eventId: '' } };
			case SearchResultType.EVENT: return { name: Routes.EVENT, params: { eventId: searchResult.id, groupId: '' } };
			default: return '';
		}
	};


	const getImageUrl = (searchResult: SearchResult) => {
		switch (searchResult.type) {
			case SearchResultType.COMMUNITY: return '';
			case SearchResultType.GROUP: return GroupsLogoStore.get(searchResult.id).src;
			case SearchResultType.EVENT: return EventsLogoStore.get(searchResult.id).src;
			default: return '';
		}
	};

	const getImageAlt = (searchResult: SearchResult) => {
		switch (searchResult.type) {
			case SearchResultType.COMMUNITY: return 'community.search.imageAlt';
			case SearchResultType.GROUP: return 'groups.search.imageAlt';
			case SearchResultType.EVENT: return 'events.search.imageAlt';
			default: return '';
		}
	};

	const results = await search(type, resultType, query);
	return results.map((result) => ({
		key: result.id,
		title: result.name,
		subtitle: getSubtitle(result),
		source: result.type,
		url: getUrl(result),
		imageUrl: getImageUrl(result),
		imageAlt: getImageAlt(result),
		fetchImage: () => result.type === SearchResultType.GROUP ? GroupsLogoStore.fetch(result.id) : EventsLogoStore.fetch(result.id),
		original: result,
	}));
}
